import { render, staticRenderFns } from "./RulesBtn.vue?vue&type=template&id=2c0d53ea&scoped=true&"
import script from "./RulesBtn.vue?vue&type=script&lang=js&"
export * from "./RulesBtn.vue?vue&type=script&lang=js&"
import style0 from "./RulesBtn.vue?vue&type=style&index=0&id=2c0d53ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d53ea",
  null
  
)

export default component.exports